import { getGlobalArgs } from '@/root/global';
import { equals } from '@/utils/common';
import { COMMON_REQUEST_HEADERS, makeQueryBuilder } from '@/utils/restClientBuilder';
import { getTraceParent } from '@/utils/restClientBuilder/helpers';

const traceHeaders = equals(getGlobalArgs('NEXT_PUBLIC_ENV', 'local'), 'local')
  ? {}
  : { [COMMON_REQUEST_HEADERS.traceParent]: getTraceParent() };

const traceParentQueryBuilder = makeQueryBuilder(() => traceHeaders);

const baseQueryBuilder = makeQueryBuilder();

export const analyticsGatewayV1 = traceParentQueryBuilder.createInstance({
  baseURL: `${getGlobalArgs('NEXT_PUBLIC_BACKEND_URL', '')}/analyticsgateway/v1`,
});

export const backendApiInstance = traceParentQueryBuilder.createInstance({
  baseURL: `${getGlobalArgs('NEXT_PUBLIC_BACKEND_URL', '')}`,
});

export const selfApiGlossaryInstance = baseQueryBuilder.createInstance({
  baseURL: getGlobalArgs('NEXT_PUBLIC_GLOSSARY_PROXY_URL', ''),
});

export const oidcApiV1 = baseQueryBuilder.createInstance({
  baseURL: `${getGlobalArgs('NEXT_PUBLIC_OIDC_AUTHORITY_URL', '')}/api/v1`,
  withCredentials: true,
});
